import Header from "../components/Header";
import OffersTable from "./components/OffersTable";

function Offers() {

    let pagesLinks = [

        {
            name: "العروض",
            link: `/admin/offers`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
    ];

    return (
        <div>

            <Header pageName="العروض" pages={pagesLinks} className="text-2xl" />

            <OffersTable />

        </div>
    )
}

export default Offers